import { checkRoutePermission } from '@/router/permissionRoutes';

/** 与路由守卫、permissionRoutes 中 ProjectCreate 一致，不直接依赖 Pinia 类型 */
export type ProjectCreatePermissionStoreLike = {
  hasPermissions: (codes: string | string[], requireAll?: boolean) => boolean;
  hasRoles: (codes: string | string[], requireAll?: boolean) => boolean;
  checkMatrixPermission?: (leafCode: string) => boolean;
};

/** 是否允许进入 ProjectCreate / 调用创建项目相关接口（与 routePermissionMap.ProjectCreate 一致） */
export function canAccessProjectCreateRoute(store: ProjectCreatePermissionStoreLike): boolean {
  return checkRoutePermission(
    'ProjectCreate',
    (codes, requireAll) => store.hasPermissions(codes, requireAll),
    (codes, requireAll) => store.hasRoles(codes, requireAll),
    store.checkMatrixPermission
      ? (codes, requireAll) => {
          const list = Array.isArray(codes) ? codes : [codes];
          return requireAll
            ? list.every((c) => store.checkMatrixPermission!(c))
            : list.some((c) => store.checkMatrixPermission!(c));
        }
      : undefined,
  );
}
